import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于BB彩票平台，您想了解的都在这
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="font-medium text-foreground-950 text-sm pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openId === item.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4">
                  <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}